/**
 * Service worker registration (production only, see main.tsx). When a new
 * version has been installed and is waiting, the user gets a toast to switch
 * to it; the page reloads once the new worker has taken control. The very
 * first install also takes control (clients.claim) but must not reload the
 * page: that would load everything, e.g. the whole planning, a second time.
 */
import { toast } from './toast.js';

let updateRequested = false;

function offerUpdate(worker: ServiceWorker): void {
  toast.info('Er is een nieuwe versie van TransectLibre beschikbaar.', {
    duration: 0,
    action: {
      label: 'Vernieuwen',
      onClick: () => {
        updateRequested = true;
        worker.postMessage({ type: 'SKIP_WAITING' });
      },
    },
  });
}

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  // Without a controller at load, the first controller is the first install, not an update.
  const hadController = navigator.serviceWorker.controller !== null;
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading || !(hadController || updateRequested)) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => {
        if (reg.waiting && navigator.serviceWorker.controller) offerUpdate(reg.waiting);
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            // Only an update (not the very first install) needs the user's go-ahead.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) offerUpdate(installing);
          });
        });
        // Long-lived tabs (planners keep the app open all day): look for updates hourly.
        setInterval(() => void reg.update().catch(() => undefined), 60 * 60 * 1000);
      })
      .catch(() => undefined);
  });
}
